import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext, toDate } from 'core/utils';
import { LocalPatientService } from "application/patient/services";
import { action } from 'mobx';

@applicationContext
class PatientMissingDocsSearchViewStore extends BaseViewStore {
    constructor(rootStore) {
        super(rootStore);

        const service = new LocalPatientService(rootStore.application.baasic.apiClient);

        this.localPatientStore = new BaasicDropdownStore({
            filterable: true,
            textField: "name",
        }, {
            fetchFunc: async (term) => {
                const response = await service.find({
                    sort: "lastName|asc",
                    searchQuery: term,
                    rpp: 100
                });

                return response.data.item.map(item => {
                    return {
                        name: `${item.lastName}, ${item.firstName} ${toDate(item.dateOfBirth)}`,
                        ...item
                    }
                });
            },
            onClose: () => {
                var patient = this.localPatientStore.items.find(x => x.name === this.patientName);
                if (this.patientName && patient) {
                    return this.rootStore.routerStore.goTo('master.app.main.patient-missing-docs.preview', { id: patient.id });
                }
            }
        });

        this.fetch([() => { }]);
    }

    @action.bound
    setPatientName(value) {
        this.patientName = value;
    }
}

export default PatientMissingDocsSearchViewStore;
